import React, { useRef, useEffect } from "react";
import { Helmet } from "react-helmet";
import { motion, useAnimation } from "motion/react";
import "./InformationV2.css";
import agentKeys from "../../assets/imgs/agentpics/agent-holding-keys.jpg";
import agentIpad from "../../assets/imgs/agentpics/AgentonIpad.jpg";
import agentLaptop from "../../assets/imgs/agentpics/AgentonLaptop.jpg";
import agentRaise from "../../assets/imgs/agentpics/AgentRaise.jpg";
import diningRoom from "../../assets/imgs/agentpics/BiegeDiningRoom.jpg";
import blueHouse from "../../assets/imgs/agentpics/Big Blue House with People.jpg";
import concierge from "../../assets/imgs/agentpics/concierge.jpg";
import coupleBought from "../../assets/imgs/agentpics/Couple Bought Home.jpg";
import happyFamily from "../../assets/imgs/agentpics/HappyFamilyRuning.jpg";
import threePeople from "../../assets/imgs/agentpics/ThreePeopleComingToADeal.jpg";

const infoData = [
    {
        id: "01",
        title: "Professional Real Estate Websites for Agents & Teams",
        text: "Build a high-impact website crafted for real estate professionals. Perfect for agents, teams, and brokerages.",
        image: agentKeys,
    },
    {
        id: "02",
        title: "Mobile-Optimized & Responsive Design",
        text: "Enjoy a experience on any device. Our responsive design ensures your site looks great on desktop, tablet, or mobile, connecting you with every prospect.",
        image: agentIpad,
    },
    {
        id: "03",
        title: "Customizable Templates & Complete Control",
        text: "Choose from a variety of stylish templates built for real estate, and manage your site effortlessly with our secure dashboard and intuitive tools.",
        image: agentLaptop,
    },
    {
        id: "04",
        title: "Built-In SEO & Marketing Tools",
        text: "Enhance your online presence with integrated SEO features and marketing tools designed to attract more leads and boost your brand.",
        image: agentRaise,
    },
    {
        id: "05",
        title: "Affordable, All-Inclusive Plans",
        text: "Have your own website without breaking the bank. Our cost-effective plans provide everything you need to thrive in a competitive market.",
        image: coupleBought,
    },
    {
        id: "06",
        title: "IDX Integration for Listings",
        text: "Seamlessly display all your MLS listings on your website with our IDX support. Keep your site up-to-date and provide visitors with the latest properties automatically.",
        image: blueHouse,
    },
    {
        id: "07",
        title: "Social Media Integration & Add-Ons",
        text: "Expand your reach with our social media add-ons. We offer professional management, content creation, and analytics to help you grow your brand across all major platforms.",
        image: concierge,
    },
    {
        id: "08",
        title: "Domain Management & Acquisition",
        text: "Let us handle your domain needs! We can acquire a custom domain for you and set it up so your APTO Website is live at your own branded address.",
        image: happyFamily,
    },
    {
        id: "09",
        title: "Professional Email Hosting",
        text: "Get professional email addresses using your new domain (e.g., you@yourdomain.com). We provide reliable email hosting so your business looks credible and stays connected.",
        image: threePeople,
    },
];

const InformationV2 = () => {
    const containerVariants = {
        hidden: {},
        visible: {
            transition: {
                delay: 0.2,
                staggerChildren: 0.3,
            }
        }
    }

    const childVariants = {
        hidden: { opacity: 0, y: 50 },

        visible: {
            opacity: 1,
            y: 0,
            transition: { type: "spring", stiffness: 120, damping: 15 }
        }
    };

    return (
        <>
            <Helmet>
                <title>Real Estate Website Features | AptoWebsites</title>
                <meta name="description" content="Discover the features of AptoWebsites: mobile-optimized, SEO-ready, IDX integration, social media add-ons, and more for real estate professionals." />
                <meta name="keywords" content="real estate website features, IDX, SEO, mobile, social media, AptoWebsites" />
                <meta property="og:title" content="Real Estate Website Features | AptoWebsites" />
                <meta property="og:description" content="Discover the features of AptoWebsites: mobile-optimized, SEO-ready, IDX integration, social media add-ons, and more." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/" />
            </Helmet>
            {/* <section className="info-v2-hero">
                <div className="info-v2-hero-inner">
                    <h1 className="info-v2-title">
                        <span>Comprehensive</span> Real Estate Website Features
                    </h1>
                    <p className="info-v2-subtitle">
                        Everything you need to stand out, attract leads, and grow your real estate business online.
                    </p>
                </div>
            </section> */}
            {/* <div className="info-v2-list">
                {infoData.map((section, idx) => (
                    <div className={`info-v2-card${idx % 2 === 1 ? " reverse" : ""}`} key={idx}>
                        <div className="info-v2-image-wrap">
                            <img src={section.image} alt={section.title} className="info-v2-image" />
                        </div>
                        <div className="info-v2-content">
                            <h2>{section.title}</h2>
                            <p>{section.text}</p>
                        </div>
                    </div>
                ))}
            </div> */}

            <motion.div variants={containerVariants}
                initial="hidden"
                whileInView={"visible"}
                viewport={{ once: true, amount: 0.1 }}>
                <motion.h2
                    className="service-title"
                    variants={{
                        hidden: { opacity: 0, y: -100 },
                        visible: {
                            opacity: 1,
                            y: 0,
                            transition: { type: "spring", stiffness: 150, damping: 10 }
                        }
                    }}
                >
                    Our Services
                </motion.h2>

                <div className="info-v2-list">
                    {infoData.map((section, id) => {
                        const isReverse = id % 2 === 1;
                        return (
                            <motion.div
                                className={`info-v2-card ${isReverse ? "reverse" : ""}`}
                                key={id}
                                variants={childVariants}
                                whileHover={{
                                    scale: 1.03,
                                    y: -5,
                                    boxShadow: "0px 15px 40px rgba(0,0,0,0.15)"
                                }}
                                transition={{ type: "spring", stiffness: 200, damping: 15 }}
                            >
                                <motion.div
                                    className="info-v2-image-wrap"
                                    variants={{
                                        hidden: isReverse ? { opacity: 0, x: 60 } : { opacity: 0, x: -60 },
                                        visible: { opacity: 1, x: 0, transition: { type: "spring", stiffness: 100, damping: 15 } }
                                    }}
                                >
                                    <img src={section.image} alt={section.title} className="info-v2-image" />
                                </motion.div>
                                <motion.div
                                    className="info-v2-content"
                                    variants={{
                                        hidden: isReverse ? { opacity: 0, x: -60 } : { opacity: 0, x: 60 },
                                        visible: { opacity: 1, x: 0, transition: { type: "spring", stiffness: 100, damping: 15 } },
                                    }}
                                >
                                    <h3>{section.title}</h3>
                                    <p>{section.text}</p>
                                </motion.div>
                            </motion.div>
                        )
                    })}
                </div>
            </motion.div >
        </>
    );
};

export default InformationV2;
